import React from "react"
import "./smallSpin.css"

const SmallSpin = () => {
	return <div className="spinner"></div>
}

export default SmallSpin
